import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

// 配置开发环境
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.config.performance = true

// 配置Element UI
Vue.use(ElementUI)

// 根据当前协议自动选择API地址
const protocol = window.location.protocol
const apiURL = `${protocol}//${window.location.host}/api`
console.log('当前API地址:', apiURL)
axios.defaults.baseURL = apiURL
axios.defaults.timeout = 30000
axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store'
axios.defaults.headers.common['Pragma'] = 'no-cache'
axios.defaults.headers.common['Expires'] = '0'

// 请求拦截器
axios.interceptors.request.use(config => {
  console.log('%c[API请求]', 'color: blue; font-weight: bold', config.method.toUpperCase(), config.url, config.data || {})
  const customerId = localStorage.getItem('activeCustomerId')
  if (customerId) {
    config.headers['X-Customer-Id'] = customerId
  }
  // 添加时间戳避免缓存
  if (config.method === 'get') {
    config.params = { ...config.params, _t: Date.now() }
  }
  return config
}, error => {
  console.error('%c[API请求错误]', 'color: red; font-weight: bold', error)
  return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use(response => {
  console.log('%c[API响应]', 'color: green; font-weight: bold', response.config.url, response.data)
  return response
}, error => {
  console.error('%c[API响应错误]', 'color: red; font-weight: bold', error)
  return Promise.reject(error)
})

Vue.prototype.$http = axios

let dspConfigPromise = null
let dspConfigCache = null

// 获取DSP配置
Vue.prototype.$getDspConfig = async function(forceRefresh = false) {
  if (!forceRefresh && dspConfigCache) {
    return dspConfigCache
  }
  if (!forceRefresh && dspConfigPromise) {
    return dspConfigPromise
  }
  dspConfigPromise = (async () => {
  try {
    const response = await axios.get('/config')
    if (response.data && response.data.code === 0) {
      const { dsp_name, dsp_title, icp_license_no, customers, default_customer_id } = response.data.data
      Vue.prototype.$dspName = dsp_name
      Vue.prototype.$dspTitle = dsp_title
      Vue.prototype.$icpLicenseNo = icp_license_no || ''
      if (customers && customers.length && !localStorage.getItem('activeCustomerId')) {
        localStorage.setItem('activeCustomerId', default_customer_id || customers[0].id)
      }
      // 更新文档标题
      document.title = dsp_title
      console.log(`DSP配置加载成功: ${dsp_name} - ${dsp_title}`)
      dspConfigCache = response.data.data
      return dspConfigCache
    }
  } catch (error) {
    console.error('获取DSP配置失败:', error)
    // 使用默认值
    Vue.prototype.$dspName = 'dsp'
    Vue.prototype.$dspTitle = '艾克斯广告平台'
    Vue.prototype.$icpLicenseNo = ''
    document.title = '艾克斯广告平台'
  }
  return null
  })()
  try {
    return await dspConfigPromise
  } finally {
    dspConfigPromise = null
  }
}

new Vue({
  router,
  store,
  data() {
    return {
      appConfig: {
        showActivityConversionLeads: true
      }
    }
  },
  render: h => h(App),
  async created() {
    // 初始化时加载DSP配置
    const config = await this.$getDspConfig()
    if (config && typeof config.show_activity_conversion_leads === 'boolean') {
      this.appConfig.showActivityConversionLeads = config.show_activity_conversion_leads
    }
  }
}).$mount('#app') 
